"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _DataStoreComponent2 = _interopRequireDefault(require("../DataStoreComponent/DataStoreComponent2"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Subclass this class for custom checks
 */
var CheckCanOpenComponent = /*#__PURE__*/function (_DataStoreComponent) {
  (0, _inherits2["default"])(CheckCanOpenComponent, _DataStoreComponent);

  var _super = _createSuper(CheckCanOpenComponent);

  function CheckCanOpenComponent(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, CheckCanOpenComponent);
    _this = _super.call(this, props);

    if (_this.props && _this.props.registerAsCheckerComponent) {
      _this.props.registerAsCheckerComponent(_this.props.chapterType, (0, _assertThisInitialized2["default"])(_this));
    }

    return _this;
  }
  /**
   * Implement this method in subclasses
   */


  (0, _createClass2["default"])(CheckCanOpenComponent, [{
    key: "onOpen",
    value: function () {
      var _onOpen = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.error("This method must be overwritten by subclasses! Called from ".concat(this.constructor.name));
                return _context.abrupt("return", _promise["default"].resolve(true));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onOpen() {
        return _onOpen.apply(this, arguments);
      }

      return onOpen;
    }() // noinspection JSMethodCanBeStatic

  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return CheckCanOpenComponent;
}(_DataStoreComponent2["default"]);

CheckCanOpenComponent.propTypes = {
  chapterType: _propTypes["default"].string,
  registerAsCheckerComponent: _propTypes["default"].func
};
var _default = CheckCanOpenComponent;
exports["default"] = _default;